export default __webpack_public_path__ + "static/media/voha-3.5fa17bf1.png";